














import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

@Component
export default class SinglePickerCard extends Vue {
  @Prop(Object) item: any;
  @Prop([String, Object]) selected: string | {};
  @Prop(Boolean) filledChipsStyle: false;

  isClicked: boolean = false;

  /*
    Returns the selected object. As it is a single select, there is no 'unselected'
    mode, so the component always returns a value
  */
  @Emit('item-selected')
  itemSelected () {
    this.isClicked = !this.isClicked;
    return this.item.id;
  }

  /* Handle the style of the button in template */
  get buttonClass () {
    const unselectedStyle = this.filledChipsStyle ? 'FilledChips' : 'WiredChips';
    return this.selected === this.item.id ? 'Btn-filled-gray' : unselectedStyle;
  }
}
